export class Table {
	Id: number;
	Name: string;
}